import React, { useState } from 'react';
import ImportStepInput from './ImportStepInput';
import ImportStepPreview from './ImportStepPreview';
import ImportLayout from './ImportLayout';

export default function ImportPage() {
  const [step, setStep] = useState<'input' | 'preview'>('input');
  const [rawInput, setRawInput] = useState('');
  const [parsedRecipes, setParsedRecipes] = useState<any[]>([]); // Will type after pipeline is set
  const [rawLLMOutput, setRawLLMOutput] = useState<string | null>(null);

  return (
    <ImportLayout title="Batch Recipe Import">
      {step === 'input' && (
        <ImportStepInput
          rawInput={rawInput}
          setRawInput={setRawInput}
          setParsedRecipes={setParsedRecipes}
          setRawLLMOutput={setRawLLMOutput}
          goToPreview={() => setStep('preview')}
        />
      )}
      {step === 'preview' && (
        <ImportStepPreview
          recipes={parsedRecipes}
          rawLLMOutput={rawLLMOutput}
          goBack={() => setStep('input')}
        />
      )}
    </ImportLayout>
  );
}
